<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list>
        <v-row>
          <v-col md="3">
            <div style="margin-left:5px;">
              <img class="rounded-pill" :src="foto" alt="avatar" width="50px;" />
            </div>
          </v-col>
          <v-col md="6" style="margin-top:8px;">
            <span class="text-size-custom font-weight-bold text-truncate">
              {{ formatarNome(loggedUserName) }}
            </span><br>
            <span class="role-text text-truncate">{{ role_descricao }}</span>
          </v-col>
        </v-row>
      </v-list>

      <!--=== CONTAINER DE PESQUISA DE PÁGINA ====-->
      <div class="mt-3">
        <v-text-field v-model="rotaPesquisada" @input="pesquisarRotas" append-icon="mdi-magnify"
          @click:append="pesquisarRotas" placeholder="Localizar página" outlined dense rounded class="mx-2"
          style="max-width: 280px;"></v-text-field>

      </div>
      <!--=== FIM CONTAINER DE PESQUISA DE PÁGINA ====-->

      <!--=== CONTAINER DE EXIBIÇÃO DO MENUS  ====-->
      <template>
        <v-list>
          <v-list-item v-for="rota in rotasFiltradas" :key="rota.id" @click="redirecionarRota(rota)"
            :class="{ 'v-list-item--active': rotaAtiva === rota.id }" class="rota-item">
            <v-list-item-action>
              <v-icon>{{ rota.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ rota.descricao }}
              </v-list-item-title>
            </v-list-item-content>
            <div v-if="rota.novo == 1" class="novo-badge">Novo</div>
          </v-list-item>
        </v-list>

      </template>
      <!--=== FIM CONTAINER DE EXIBIÇÃO DO MENUS  ====-->
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app :color="'blue darken-3'" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
          <v-icon>menu</v-icon></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">{{ sigla }}</span>
      </v-toolbar-title>

      <span>
        Ano lectivo:
        {{ anolectivo }}

      </span>
      <v-spacer></v-spacer>
      <span class="text-uppercase">
        {{ instituicaodescricao }}

      </span>
      <v-spacer></v-spacer>

      <template
        v-if="($store.state.solicitacoesPendentes >= 1 || $store.state.solicitacoesTransferenciaPendentes >= 1) && role === 'ROLE_PED'">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div style="position: relative; display: inline-block;">
              <v-btn icon v-on="on">
                <v-badge color="green"
                  :content="$store.state.solicitacoesPendentes + $store.state.solicitacoesTransferenciaPendentes">
                  <v-icon color="white">mdi-bell</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card width="300" class="notification-card">
            <v-list>
              <v-list-item v-if="$store.state.solicitacoesPendentes >= 1"
                @click="$router.push('/impressao/solicitacoes')">
                <v-list-item-icon>
                  <v-icon color="warning">mdi-printer</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="notification-title">
                    Documentos Pendentes
                  </v-list-item-title>
                  <v-list-item-subtitle class="notification-subtitle">
                    {{ $store.state.solicitacoesPendentes }} documento(s) aguardando impressão.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="$store.state.solicitacoesPendentes >= 1 && $store.state.solicitacoesTransferenciaPendentes >= 1"></v-divider>
              <v-list-item v-if="$store.state.solicitacoesTransferenciaPendentes >= 1"
                @click="$router.push('/estudante/transferencia-pendentes')">
                <v-list-item-icon>
                  <v-icon color="info">mdi-transfer</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="notification-title">
                    Transferências Pendentes
                  </v-list-item-title>
                  <v-list-item-subtitle class="notification-subtitle">
                    {{ $store.state.solicitacoesTransferenciaPendentes }} transferências aguardando aprovação.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </template>

      <template>
        <div class="text-center" width="800px">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>account_circle</v-icon>
              </v-btn>
            </template>
            <v-card width="300">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-row class="d-flex align-center">
                      <v-col md="2">
                        <v-list-item-avatar>
                          <img class="photomouse" ref='image' :src="foto" alt="avatar" width='123px' height='123px' />
                           <input style="display:none" ref="input" type="file" name="image" accept="image/*" @change="setImage" />
                           </v-list-item-avatar>

                      </v-col>

                      <v-col md="10">
                        <v-list-item-title class="user-name-title">{{ loggedUserName }}</v-list-item-title>
                        <v-list-item-subtitle class="user-email">{{ loggedEmail }}</v-list-item-subtitle>
                      </v-col>
                    </v-row>

                    <v-list-item-subtitle>
                      <v-row class="d-flex align-center justify-start mt-1 mb-1">
                        <v-col md="3" class="d-flex justify-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small fab color="#006699" @click="showFileChooser()" v-bind="attrs" v-on="on">
                                <v-icon color="white" small>add_a_photo</v-icon>
                              </v-btn>
                            </template>
                            <span>Carregar foto de perfil</span>
                          </v-tooltip>
                        </v-col>

                        <v-col md="3" class="d-flex justify-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small fab color="#006699" to="/perfil" v-bind="attrs" v-on="on">
                                <v-icon color="white" small>vpn_key</v-icon>
                              </v-btn>
                            </template>
                            <span>Clique aqui para alterar a sua Palavra-Passe</span>
                          </v-tooltip>
                        </v-col>

                        <v-col md="3" class="d-flex justify-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small fab color="#006699" style="color:white;" v-bind="attrs" v-on="on">
                                <v-icon color="white" small>desktop_mac</v-icon>
                              </v-btn>
                            </template>
                            <span>Clique aqui para saber mais sobre o sistema Eltsys e a versão que está a
                              utilizar.</span>
                          </v-tooltip>
                        </v-col>

                        <v-col md="3" class="d-flex justify-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small fab color="#006699" style="color:white;" v-bind="attrs" v-on="on">
                                <v-icon color="white" small>location_on</v-icon>
                              </v-btn>
                            </template>
                            <span>Saiba a sua localização, clicando aqui!</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>

                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>info</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>Sobre nós</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="$router.push('licencaStatus')"
                  v-if="(role === 'ROLE_ADM') || (role === 'ROLE_PED')">
                  <v-list-item-action>
                    <v-icon>payments</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>Licença</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="Call_Sair()">
                  <v-list-item-action>
                    <v-icon>logout</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>Terminar Sessão</v-list-item-title>
                </v-list-item>
                <v-divider v-if="role === 'ROLE_ADM'"></v-divider>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </template>
      <template>
        <v-dialog v-model="dialogo" fullscreen hide-overlay transition="dialog-bottom-transition">

          <v-card>
            <v-toolbar color="blue darken-3" dark>
              <v-btn icon dark @click="dialogo = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title><v-btn dark text @click="dialogo = false">Fechar </v-btn></v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
            <v-list>
              <v-row>
                <v-col cols="2"><v-subheader>Usuários Activos</v-subheader></v-col>
                <v-col cols="1"><v-btn @click="MostraUsuariosActivos()"><v-icon
                      color="green">cached</v-icon></v-btn></v-col>
                <v-col cols="4">

                  <v-progress-circular v-if="progresso" color="green" indeterminate></v-progress-circular>

                </v-col>
              </v-row>
              <v-row>
                <v-col col="4">
                  <v-list-item v-for="(item, i) in usuarios" :key="i">

                    <v-list-item-icon>
                      <v-icon v-if="item.status === 'ON'" small color="green">fiber_manual_record</v-icon>
                      <v-icon v-if="item.status === 'OFF'" small color="orange">fiber_manual_record</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title small>
                        <span class="user-number">{{ i + 1 }}.</span>
                        <span class="user-name">{{ item.nome }}</span>
                        <span class="user-institution">{{ item.instituicao }}</span>
                      </v-list-item-title>
                      <v-list-item-title v-if="item.status === 'ON'" small class="user-status">Online a <span
                          class="user-status">{{ MostraHoraMinuto(CalculoDosMinutos(new Date(item.data_in) - new
                            Date(item.data_sistema))) }}</span></v-list-item-title>
                      <v-list-item-title
                        v-if="CalculoDosMinutos(new Date(item.data_in) - new Date(item.data_sistema)) === 0" small
                        class="user-status">Online agora</v-list-item-title>
                      <v-list-item-title v-if="item.status === 'OFF'" small class="user-status">Inativo a
                        {{ MostraHoraMinuto(CalculoDosMinutos(new Date(item.data_in) - new Date(item.data_sistema))) }}
                        minutos</v-list-item-title>
                    </v-list-item-content>

                  </v-list-item>
                </v-col>
              </v-row>

            </v-list>
          </v-card>
        </v-dialog>
      </template>

    </v-app-bar>

    <v-content class="circular"
      v-bind:style="{ backgroundImage: (isBendizer) ? 'url(/img/bg20.jpg)' : 'url( https://cdn.vuetifyjs.com/images/parallax/material.jpg)' }">
 <div v-if="paginas.length">
  <v-breadcrumbs :items="paginas" style="background-color: #fff;" divider="/"></v-breadcrumbs>

   <v-alert
    border="left"
    colored-border
    type="warning"
    elevation="2"
    class="mt-2 mb-0 rounded-lg"
    v-model="mostrarAlerta"
    v-if="diasLeftsPassWordActive >0 && diasLeftsPassWordActive<=10"
    dismissible
    transition="scale-transition"
>
    <div class="d-flex align-center">
        <v-icon left color="warning">mdi-alert-circle-outline</v-icon>
        <div>
            Sua senha expirará em  <strong>{{diasLeftsPassWordActive}} dia(s)</strong>.
            <v-btn 
                text
                color="warning darken-1" 
                @click="MudarSenhaPerfil()"
                 class="ml-2 px-1 text-decoration-underline"
                small
            >
                Atualizar agora
            </v-btn>
        </div>
    </div>
</v-alert>
</div>
 

      <v-btn v-if="paginas.length > 1" class="botao_de_voltar" @click="voltar()" color="blue" fab small> <v-icon small
          color="white">arrow_back</v-icon> </v-btn>

      <v-card class="suggestions-card" v-if="$store.state.versugestao">
        <!-- Header -->
        <v-card-title class="d-flex justify-space-between align-center pa-4"
          style="background-color: #f5f5f5; border-bottom: 1px solid #e0e0e0;">
          <div class="d-flex align-center">
            <v-icon color="blue darken-2" left class="mr-2">mdi-clipboard-list-outline</v-icon>

            <span class="text-h6 font-weight-bold blue--text text--darken-2">
              Trabalho em progresso
            </span>
          </div>

          <v-btn @click="fecharSugestao()" icon small color="grey darken-1">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Conteúdo rolável -->
        <div class="flex-grow-1 overflow-y-auto pa-3">
          <v-list dense>
            <v-list two-line>
              <template>
                <v-list-item v-for="(item, index) in lista_sugestoes" :key="item.id" two-line class="rounded-lg"
                  elevation="0" :class="index % 2 === 0 ? ['bg-grey', 'lighten-5'] : ['bg-grey', 'lighten-4']">
                  <v-list-item-content>
                    <v-list-item-title class="suggestion-title">
                      {{ index + 1 }}. {{ item.sugestao }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="suggestion-subtitle">
                      {{ item.descricao }} -
                      <span class="suggestion-author">sugerido por: Anónimo</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-chip small class="ma-2" :color="'grey lighten-3'" :text-color="estadoColor(item.status_)" label
                    outlined>
                    <v-icon left small :color="estadoColor(item.status_)">
                      {{ estadoIcon(item.status_) }}
                    </v-icon>
                    {{ item.status_ }}
                  </v-chip>
                </v-list-item>
                <v-divider :key="'divider-' + index"></v-divider>
              </template>
            </v-list>

          </v-list>
        </div>

        <v-divider></v-divider>

        <!-- Footer fixo no fim -->
        <v-card-actions class="justify-center pa-3">
          <span class="text-caption grey--text">&copy; 2025 Softline Angola</span>
        </v-card-actions>
      </v-card>

      <router-view />

    </v-content>

    <!-- ********************************************************************************************** -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoUpload" persistent max-width="450px">
          <v-card>
            <v-card-title class="upload-title">
              <span class="text-h5">Carregar foto </span><br>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="2" md="2"></v-col>
                  <v-col cols="12" sm="10" md="10">
                    <v-col md="8">
                      <div>
                        <div class="content">
                          <section class="cropper-area">
                            <div class="img-cropper">
                              <vue-cropper v-if="imgSrc !== ''" ref="cropper" :aspect-ratio="20 / 20" :src='imgSrc'
                                preview=".preview" />
                            </div>
                          </section>
                          <v-btn v-if="imgSrc !== ''" small @click.prevent="cropImage" fab dark color="#808080"><v-icon
                              small dark>crop</v-icon></v-btn>

                        </div>
                      </div>
                    </v-col>
                  </v-col>
                </v-row>
                <hr>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="reset()">Cancelar</v-btn>
                  <v-btn color="blue" text @click="cropImage()">Cortar</v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>

          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ******************************************************************************************************* -->

    <v-content class="circular" height="300" v-bind:style="{ backgroundImage: 'url( /img/logo.jpg )' }">

      <v-tooltip top v-if="!showUserOline">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" @click="mostrarUser()" class="botao_de_usuario" v-if="!showUserOline">
            <span>{{ usuariosActivos.length }}</span>
          </div>
        </template>
        <span>Existe(m) {{ usuariosActivos.length }} usuário(s) online.</span>
      </v-tooltip>

      <v-card class="usuarios_logados_container" v-if="showUserOline">
        <v-card-title class="container_titulo">
          <span class="text-subtitle-1">Usuários Online</span>
          <v-btn small fab color="red" @click="hiddeUser()"><v-icon style="color:white;">close</v-icon></v-btn>
        </v-card-title>

        <v-list two-line v-for="(item, index) in usuariosActivos" :key="item.username">
          <template class="container_usuarios">
            <v-subheader v-if="item.header" :key="item.header"></v-subheader>

            <v-divider v-if="index != 0"></v-divider>

            <v-list-item>
              <v-list-item-avatar>
                <img :src="foto" />
              </v-list-item-avatar>

              <v-list-item-content>
            <v-list-item-title><span style="font-size:11px;">{{item.nome.split(' ')[0]+' '+item.nome.split(' ')[item.nome.split(' ').length-1]}}</span> - <span style="font-size:9px;font-weight:bold;">{{item.instituicao.split(' ')[0]+' '+item.instituicao.split(' ')[item.instituicao.split(' ').length-2]+' '+item.instituicao.split(' ')[item.instituicao.split(' ').length-1]}}</span></v-list-item-title>
            <v-list-item-subtitle v-if="item.status === 'ON' && CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)) > 0 " small style="font-size:12px;color:grey;">Online a <span style="font-size:12px;color:grey;">{{MostraHoraMinuto(CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)))}}</span></v-list-item-subtitle>
            <v-list-item-title v-if="CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)) === 0 " small style="font-size:12px;color:grey;">Online agora</v-list-item-title>
             
          </v-list-item-content>

          <v-list-item-action>
          <v-btn icon>
            <span class="span_cor"></span>
          </v-btn>
        </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>

    

  </v-card>
       
    </v-content>

    <add-sugestao></add-sugestao>
    <actualizar-senha></actualizar-senha>
  </v-app>
</template>

<script>

import axios from '@/plugins/axios'
import photoUser from '@/utilitarios/photo.services'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Swal from 'sweetalert2'
import { getState } from './state'
import AddSugestao from './components/addSugestao'
import ItensMenuUtilitarios from './utilitarios/ItensMenuUtilitarios'
 import funcaoUtilitarios from './utilitarios/funcaoUtilitarios'
import _axios from './plugins/axios'
import utilitarios from './plugins/utilitarios'
import ActualizarSenha from './views/tec-ped/ActualizarSenha.vue'
var ls = require('local-storage')
export default {
  components: {
    VueCropper,
    AddSugestao,
    ActualizarSenha
   },
  data: () => ({
    foto: '',
    dialogoUpload: false,
    showUserOline: false,
    showMudarSenha: false,
    utilitarios:utilitarios,
    imgSrc: '',
    cropImg: '',
    lista_sugestoes: [],

    sugestoes: [
      { titulo: 'Lista de Professores que não Lançaram notas', subtitulo: 'Verificar até sexta-feira', estado: 'Novo' },
      { titulo: 'Turmas com notas incompletas', subtitulo: 'Faltam notas de Matemática', estado: 'Progresso' },
      { titulo: 'Alunos sem matrícula ativa', subtitulo: 'Atualizar status no sistema', estado: 'Completo' },
      { titulo: 'Sugestão arquivada', subtitulo: 'Sem necessidade de ação', estado: 'Fechado' }
    ],
    usuariosActivos: [],

    rotasFiltradas: [],
    rotaPesquisada: '',
    rotaAtiva: null,
    rotasPadrao: [],
    rotasUser: [],
    rotasArray: [],

    drawer: null,
    items: [
      { text: 'Home', icon: 'dashboard', to: 'welcome', role: 'all' },
      { icon: 'school', text: 'Estudante', to: 'estudante/menu', role: 'func' },
      { icon: 'person', text: 'Funcionário', to: 'funcionario/menu', role: 'func' },
      { icon: 'control_point_duplicate', text: 'Turma', to: 'turma/menu', role: 'func' },
      { icon: 'assignment_ind', text: 'Professor', to: 'professor/menu', role: 'ped' },
      { icon: 'filter_1', text: 'Lançamento de notas', to: 'lancar-nota/menu', role: 'prof' },
      { icon: 'local_printshop', text: 'Impressão', to: 'impressao/menu', role: 'ped' },
      { icon: 'account_circle', text: 'Permissões', to: 'permissao/menu', role: 'ped' },
      { icon: 'logout', text: 'Sair', to: 'logout', role: 'all' }
    ],
  }),
  onIdle() {
    this.logout()
    this.messageStr = 'zzz'
  },
  onActive() {
    this.messageStr = 'Activo'
  },

  mounted() {
    this.carregarRotas().then(() => {
      // Espera as rotas serem carregadas, depois identifica a rota ativa com base na URL
      const rotaAtual = this.rotasUser.find(r => r.url === this.$route.path)
      if (rotaAtual) {
        this.rotaAtiva = rotaAtual.id
      }
    })
  },

  // mounted() {
  //   this.rotaAtiva = Number(localStorage.getItem('rotaAtiva')) || null
  // },

  methods: {

    getPhoto() {
      try {
        this.foto = photoUser.getPhotoUser(ls.get('idPessoa'))
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar a foto', 'error')
      }
    },

    async carregarConfiguracoesReports() {
      try {
        const response = await axios.get('/configuracoesAll')
        const data = response.data

        if (data.length > 0) {
          ls.set('configuracoesReport', data)

          const configMap = {
            api: 'api',
            urlReport: 40,
            urlFoto: 31,
            logotipo: 32,
            insignia: 33,
            subdirector: 41,
            nomeInstituicao: 42,
            directora_ims_profissao: 43,
            directora_ims: 44
          }

          Object.entries(configMap).forEach(([key, value]) => {
            const config = Array.isArray(value)
              ? data.filter(c => c.chave === value)[0]
              : data.filter(c => c.idConfiguracoes === value)[0]
            ls.set(key, config ? config.valor : '')
          })

          this.getPhoto()
        }
      } catch (error) {
        this.$refs.snackbar.mostrar('Erro ao carregar as configurações do sistema', 'error', 'top')
      }
    },

    mostrarUser() {
      this.MostraUsuariosActivos()
      this.showUserOline = true
    },
    hiddeUser() {
      this.showUserOline = false
    },

    setImage(e) {
      console.log("Veio buscar a imagem")
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        this.$refs.snackbar.mostrar('Por favor selecione uma imagem', 'warning', 'top')
      } else {
        if (typeof FileReader === 'function') {
          this.sufixOriginalname = file.name
          this.dialogoUpload = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          this.$refs.snackbar.mostrar('Ficheiro não suportado', 'warning', 'top')
        }
      }
    },

    cropImage() {
      try {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
        this.savephoto()
      } catch (error) {
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
        this.$refs.snackbar.mostrar('Ocorreu um erro ao cortar a foto', 'error', 'top')
      }
    },

    flipX() {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY() {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset() {
      try {
        this.$refs.cropper.reset()
        this.cropImg = null
      } catch (error) {
        this.$refs.snackbar.mostrar('Ocorreu um erro', 'error', 'top')
      } finally {
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
      }
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData() {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData() {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
    showFileChooser() {
      this.$refs.input.click()
    },
    async savephoto() {
      try {
        this.$store.state.isloading = true
        let fileName = ls.get('idPessoa') + '.png'
        let params = { fileName: fileName, ficheiro: this.cropImg, sigla: ls.get('sigla') + '/usuarios' }
        let result = await axios({ method: 'post', url: ls.get('urlReport') + 'uploadImg', data: params }).then(res => res.data)
        if (result && result.affectedRows > 0) {
          this.foto = this.cropImg
          this.$store.state.isloading = false
        }
      } catch (error) {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
        this.$refs.snackbar.mostrar('Ocorreu um erro ao realizar a operação', 'error', 'top')
      } finally {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
      }
    },

    voltar() {
      this.$router.push(this.paginas[this.paginas.length - 2].to)
    },

    carregamenu() {
      const role = ls.get('role')
      if (role === 'ROLE_DIR') {
        this.menus = this.items.filter(m => m.role === 'all' || m.role === 'func' || m.role === 'prof' || m.role === 'ped' || m.role === 'dir' || m.role === 'sec'
        )
      } else if (role === 'ROLE_PED') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'ped' ||
          m.role === 'coor' ||
          m.role === 'func' ||
          m.role === 'prof' ||
          m.role === 'est'
        )
      } else if (role === 'ROLE_ADM') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'ped' ||
          m.role === 'coor' ||
          m.role === 'func' ||
          m.role === 'prof' ||
          m.role === 'est' ||
          m.role === 'adm' ||
          m.role === 'dir' ||
          m.role === 'sec'
        )
      } else if (role === 'ROLE_COOR') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'coor' ||
          m.role === 'func' ||
          m.role === 'prof' ||
          m.role === 'est'
        )
      } else if (role === 'ROLE_FUNC') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'func' ||
          m.role === 'est'
        )
      } else if (role === 'ROLE_SEC') {
        this.menus = this.items.filter(m => m.role === 'all' || m.role === 'est' || m.role === 'sec' || m.role === 'func')
      } else if (role === 'ROLE_PROF') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'prof' ||
          m.role === 'est'
        )
      } else if (role === 'ROLE_EST') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'est'
        )
      } else if (role === 'ROLE_PWR') {
        this.menus = this.items.filter(m => m.role === 'all' ||
          m.role === 'ped' ||
          m.role === 'coor' ||
          m.role === 'func' ||
          m.role === 'prof' ||
          m.role === 'est'
        )
      }
      // set first element
      if (ls.get('menus') !== null) { this.menus = ls.get('menus') } // para persistir a marcação actual do menu apos a actualização do navegador.
    },

    async obterTurmasDirector() {
      this.progresso = true
      try {
        this.turmas = await axios
          .get('/listarTurmasDirector')
          .then(res => res.data)
        this.progresso = false
        if (this.turmas.length) {
          this.NaoMostrar = false
        } else {
          this.NaoMostrar = true
        }
      } catch (error) {
        this.isLoading = false
        this.progresso = false
        this.$refs.snackbar.mostrar('Ocorreu um erro ao carregar as turmas', 'error', 'top')
      }
    },

    estadoColor(estado) {
      switch (estado) {

        case 'Novo': return 'grey darken-2'
        case 'Progresso': return 'yellow darken-2'
        case 'Completo': return 'green darken-2'
        case 'Fechado': return 'grey darken-2'
        default: return 'grey'
      }
    },
    estadoIcon(estado) {
      switch (estado) {
        case 'Novo': return 'mdi-lightbulb-on-outline'
        case 'Progresso': return 'mdi-progress-clock'
        case 'Completo': return 'mdi-check-circle-outline'
        case 'Fechado': return 'mdi-close-circle-outline'
        default: return 'mdi-help-circle-outline'
      }
    },

    CalculoDosMinutos(millisec) {
      var minutes = (millisec / (1000 * 60)).toFixed(1)
      // var hours = (millisec / (1000 * 60 * 60)).toFixed(1); //
      return Math.round(Math.abs(minutes))
    },
    MostraHoraMinuto(valor) {
      let minuto = valor % 60
      let hora = Math.round(valor / 60)
      let resultado = ''
      if (hora >= 1) {
        resultado = hora + ' hora e ' + minuto + ' minutos'
      } else {
        resultado = minuto + ' minutos'
      }
      return resultado
    },

    async Call_Sair() {
      try {
        let result = await axios.post('/InsertOrUpdateLoginLogs').then(res => res.data)
      } catch (error) {
      } finally {
        ls.remove('token')
        ls.clear()
        this.$router.push('/')
      }

    },

    showDialogoAddSugestao (){
      this.$store.dispatch('toggleDialogSugestao', true); // fechar
    },


    Meu_perfil() {
      this.$router.push('/perfil')
    },
    async InitializeMensagens() {
      try {
        let mensagens = await axios
          .get('/mensagemFindAll')
          .then(res => res.data)
        ls.set('mensagensDefault', mensagens)
        this.sizeMensagensLs = ls.get('mensagensDefault')
      } catch (error) {
        this.$refs.snackbar.mostrar('Ocorreu um erro ao carregar as mensagens', 'error', 'top')
      }
    },

    async getSugestoes() {
      try {
        this.lista_sugestoes = await axios
          .get('/getSugestoes')
          .then(res => res.data)

      } catch (error) {
        this.$refs.snackbar.mostrar('Erro ao carregar as sugestões', 'error', 'top')
      }
    },

    showUsuariosActivos() {
      this.dialogo = true
    },
    async MostraUsuariosActivos() {

      this.progresso = true
      try {
        this.usuariosActivos = await axios
          .get('/usuarios-activos')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.isLoading = false
        this.progresso = false
        this.$refs.snackbar.mostrar('Ocorreu um erro ao carregar os usuários activos', 'error', 'top')
      }
    },

    UsuariosActivos() {
      this.MostraUsuariosActivos()
      this.dialogo = true
    },

    ObterDataTimeRemote() {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''
      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)
      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)
      function checkZero(data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    fecharSugestao() {
     this.$store.dispatch('toggleSugestao', false); // abrir
    },

    MudarSenhaPerfil () {
       this.$store.dispatch('toggleMudarSenha', true); // abrir       
    },

    lancarNotaDe(param) {
      if (this.clicked < 1) {
        this.clicked = 1
      }
      if (param.includes('Trimestre')) {
        const payload = [
          { param: param, idperfilpauta: param.substring(0, 1) }
        ]
        this.$store.dispatch('lancarNotaDe', payload)
      }
    },

    isLoggedUSer() {
      if (!ls.get('token')) {
        this.$router.push('/')
      }
    },

    method(param, item) {
      let index = this.menus.indexOf(item)
      if (param.includes('logout')) {
        this.Call_Sair()
      } else {
        this.removeStyleOthers(index)
        this.menus[index].setColor = 'background-color:#ccc;border-radius:10px;'
        this.menus[index].setcolorText = 'color:#006699;font-weight:bold;'
        ls.set('menus', this.menus)
        this.$router.push('/' + param)
      }
    },

    removeStyleOthers(index_) {
      this.menus.forEach(element => {
        let index = this.menus.indexOf(element)
        if (index !== index_) { this.menus[index].setcolorText = '' }
        this.menus[index].setColor = ''
      })
    },
    async logout() {
      this.Call_Sair()
    },

    /**
     * Método responsavél por redirecionar para a página clicada
    */

    redirecionarRota(rota) {
      if (this.$route.path !== rota.url) {
        this.$router.push(rota.url)
      }
      this.rotaAtiva = rota.id
      this.rotaPesquisada = ''
      this.rotasFiltradas = this.rotasPadrao
    },

    /**
     * Método responsavél por carregar todas as página registradasno banco de dados
     * Enviando o nivel do role do usuario como parametro
     * Os dados são salvos no ls para evitar pesquisar sempre na BD
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async carregarRotas() {
      try {
        const rotasSaved = JSON.parse(ls.get('rotas'))
        const rotasAll = JSON.parse(ls.get('rotasAll'))

        if (!rotasSaved || rotasAll) {
          const role = ls.get('nivel_user')
          this.rotasArray = await axios.get('/pesquisarRotas').then((res) => res.data)

          this.rotasUser = this.rotasArray.filter(obj => {
            const niveis = obj.niveis.split(',')
            return niveis.includes(`${role}`)
          })

          ls.set('rotasAll', JSON.stringify(this.rotasArray))
          ls.set('rotas', JSON.stringify(this.rotasUser))

          this.rotasPadrao = this.rotasUser.filter(r => r.menu === 1)
          this.rotasFiltradas = this.rotasPadrao
        } else {
          this.rotasArray = rotasAll
          this.rotasUser = rotasSaved
          this.rotasPadrao = this.rotasUser.filter(r => r.menu === 1)
          this.rotasFiltradas = this.rotasPadrao
        }
      } catch (error) {
        this.$refs.snackbar.mostrar('Ocorreu um erro durante o carregamento dos menus!', 'error', 'top')
      }
    },

    /**
     * Método responsavél por filtrar todas as página que batem com a descrição digitada
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async pesquisarRotas() {
      try {
        if (this.rotaPesquisada) {
          this.rotasFiltradas = this.rotasArray.filter(rota => rota.descricao.toLowerCase().includes(this.rotaPesquisada.toLowerCase()) && rota.subpagina === 0)

          if (!this.rotasFiltradas.length) {
            let params = {
              descricao: this.rotaPesquisada,
              nivel: ls.get('nivel_user') ? ls.get('nivel_user') : 0,
              user: ls.get('nomeUsuario')
            }
            await axios.post('/salvarPesquisa', params).then((res) => res.data)
          }
        } else {
          this.rotasFiltradas = this.rotasPadrao
        }
      } catch (error) {
        this.$refs.snackbar.mostrar('Ocorreu um erro ao procurar a página!', 'error', 'top')
      }
    },

   

    async carregarTotalSolicitacoes() {
      try {
        let result = await axios.get('/getTotalPendentes').then((res) => res.data)
        this.$store.state.solicitacoesPendentes = result[0].totalPendentes
      } catch (error) {
        this.$refs.snackbar.mostrar('Erro ao carregar as solicitações pendentes!', 'error', 'top')
      }
    },

    async carregarTotalTransferencia() {
      if ((this.idInstituicao == 144 || this.idInstituicao == 1 || this.idInstituicao == 5) && this.role === "ROLE_PED") {
        try {
          let result = await axios.get('/getSolicitacoesTransferencia').then((res) => res.data)
          this.$store.state.solicitacoesTransferenciaPendentes = result.length
        } catch (error) {
          this.$refs.snackbar.mostrar('Erro ao carregar as solicitações de transferencias pendentes!', 'error', 'top')
        }
      }
    },
    formatarNome(nome) {
      if (!nome) return ''

      const partes = nome.trim().split(/\s+/)

      if (partes.length === 1) {
        return partes[0]
      }

      if (partes.length === 2) {
        return partes.join(' ')
      }

      return `${partes[0]} ${partes[partes.length - 1]}`
    },

    formatarInstituicao(nome) {
      if (!nome) return ''

      const partes = nome.trim().split(' ')

      if (partes.length === 1) {
        return partes[0]
      }

      if (partes.length === 2) {
        return partes.join(' ')
      }

      return `${partes[0]} ${partes[partes.length - 1]}`
    },

  },

  props: {
    source: String
  },

  computed: {
    paginas() {
      return getState().paginas || []
    },

    diasLeftsPassWordActive(){
      let data_logged = ls.get('logged_date_control')
      let diasCounter = this.utilitarios.NumberOfDayLeft(data_logged, this.utilitarios.ObterDataActual())
      
      return diasCounter
    },

    versugestao() {
      return this.$store.state.versugestao
    },

    sigla() {
      if (window.location.host.includes('eftskw'))
        return 'EFTSKW'
      else
        return 'EFTSL'
    },

    

    isBendizer() {
      return window.location.host.includes('eftskw') || window.location.host.includes('192.168.18.16')
    },

    idInstituicao() {
      return ls.get('i_id')
    },
    anolectivoAno() {
      return ls.get('anolectivo')
    },
    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },
    anolectivo() {
      return ls.get('novadescricao')
    },
    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    username() {
      let name = ls.get('nomeUsuario').split(' ')
      return name[0] + ' ' + name[name.length - 1]
    },
    loggedEmail() {
      return ls.get('username')
    },
    role() {
      return ls.get('role')
    },
    idPessoa() {
      return ls.get('idPessoa')
    },
    telefone() {
      return ls.get('telefone')
    },
    sizeDefaultMensagens() {
      return ls.get('mensagensDefault')
    },
    role_descricao() {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'Director de Colégio'
      } else if (ls.get('role') === 'ROLE_SEC') {
        rl = 'Secretário(a) Pedagógico(a)'
      }
      return rl
    }
  },

  async created() {
    await ItensMenuUtilitarios.carregarItensMenu()
    await funcaoUtilitarios.init(false)
    this.carregarConfiguracoesReports()
    this.getSugestoes()
    this.carregarRotas()
    this.InitializeMensagens()
    this.MostraUsuariosActivos()
    this.carregamenu()
    this.isLoggedUSer()
    this.carregarTotalSolicitacoes()
    this.carregarTotalTransferencia()
  }
}
</script>
<style scoped lang="css">
.rota-item {
  position: relative;
  transition: background-color 0.2s ease;
}

.menu-item-active {
  background-color: rgba(0, 0, 0, 0.1);
  color: #000;
  font-weight: bold;
}

.v-list-item--active {
  background-color: #e0f2f1 !important;
  font-weight: bold;
}

.menu-item-active .v-list-item__action {
  color: #000;
}

.rota-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.user-text {
  font-size: 10px;
  color: grey;
}

.user-text.bold {
  font-weight: bold;
  font-size: 11px;
}

.user-text.center {
  text-align: center;
}

.user-text.name {
  font-size: 10px;
}

.user-text.institution {
  font-size: 10px;
}

.user-text.status {
  font-size: 11px;
}

.card-notification {
  width: 300px;
  padding: 16px;
}

.card-notification .title {
  font-weight: bold;
  font-size: 11px;
  margin-bottom: 6px;
}

.card-notification .subtitle {
  font-size: 10px;
  color: grey;
  margin-top: 3px;
}

.card-title.upload {
  background-color: #006699;
  color: white;
  padding: 16px;
}

.suggestions-card {
  position: fixed;
  top: 70px;
  right: 30px;
  width: 550px;
  height: 750px; /* aumentado de 85vh para 95vh */
  z-index: 9999;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  background: #fff;
  display: flex;
  flex-direction: column;
}

.suggestion-content {
  white-space: normal;
  word-break: break-word;
}

.suggestion-content.title {
  font-weight: medium;
}

.suggestion-content.subtitle {
  color: grey;
  margin-top: 4px;
}

.suggestion-content.author {
  font-size: 10px;
  color: grey;
}

.input-hidden {
  display: none;
}

.menu-item {
  cursor: pointer;
  padding: 8px 16px;
  transition: background-color 0.2s ease;
  border-radius: 4px;
}

.menu-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.menu-item.active {
  background-color: rgba(0, 0, 0, 0.1);
}

.menu-user {
  min-width: 200px;
  padding: 8px;
  border-radius: 4px;
}

.menu-user-item {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
}

.menu-user-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.input-search {
  max-width: 300px;
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
}

.suggestion-subtitle{
  font-size: 6px;
  color: grey;
  margin-top: 4px;
}

.message {
  padding: 6px 12px;
  border-radius: 4px;
  margin: 6px 0;
  font-size: 10px;
}

.message.error {
  color: #f44336;
  background-color: rgba(244, 67, 54, 0.1);
}

.message.success {
  color: #4caf50;
  background-color: rgba(76, 175, 80, 0.1);
}

.state-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}

.state-loading .message {
  margin-left: 8px;
  font-size: 14px;
  color: #666;
}

.badge-notification {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 5px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.badge-notification.success {
  background-color: #4caf50;
  color: white;
}

.badge-notification.warning {
  background-color: #ff9800;
  color: white;
}

.badge-notification.error {
  background-color: #f44336;
  color: white;
}

.botao_de_voltar {
  position: absolute;
  right: 5px;
  top: 10px;
  z-index: 100;
}

.botao_de_usuario {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  background-color: #49cc49;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  bottom: 10px;
  z-index: 100;
  cursor: pointer;
}

.usuarios_logados_container .container_usuarios {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: all .5s ease-in;
  padding: 8px 5px;
  cursor: pointer;
}

.custom-list-item {
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all .5s;
  font-size: 10px;
}

.custom-list-item:hover {
  background-color: #e7e7e7;
  transition: all .5s;
}

.custom-title {
  font-size: 11px;
  margin-left: 20px;
}

.botao_de_voltar {
  position: absolute;
  right: 5px;
  top: 10px;
  z-index: 100;
}

.botao_de_usuario {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  background-color: #49cc49;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  bottom: 10px;
  z-index: 100;
}

.usuarios_logados_container {
  width: 350px;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 10px 10px 0px 0px;
  min-height: 250px;
  background-color: #fefefe;
  border: 1px solid #ababab;
  position: absolute;
  right: 5px;
  bottom: 0px;
}

.usuarios_logados_container .container_usuarios {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: all .5s ease-in;
  padding: 8px 5px;
  cursor: pointer;
}

.container_usuarios:hover {
  background-color: #d5d1d1;
  transition: all .5s ease-in;
}

.usuarios_logados_container .container_titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #898888;
  margin-bottom: 10px;
}

.span_cor {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #3bbb3b;
  margin-right: 5px;
}

.user-name-title {
  font-size: 11px;
}

.role-text {
  font-size: 12px;
  padding: 2px;
  line-height: 10px;
}

.span_nome {
  font-size: 14px;
}

.close_btn {
  background-color: #ff0000;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  cursor: pointer;
  margin-bottom: 3px;
}

.notification-badge {
  position: absolute;
  top: -1px;
  right: -1px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: bold;
  animation: blink 1s infinite;
}

@keyframes blink {

  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

.notification-card {
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.notification-title {
  font-weight: bold;
  color: #333;
}

.notification-subtitle {
  color: #666;
  font-size: 14px;
}

.v-list-item {
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

.text-size-custom {
  font-size: 14px;
}

.hidden-input {
  display: none;
}
.user-avatar {
  width: 123px;
  height: 123px;
  border-radius: 50%;
  object-fit: cover;
}

</style>
